export const LOGIN_REGEX = {
  PHONE: /^(0?)(\d{10})$/,
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
};
